import { render, staticRenderFns } from "./blockTotal.vue?vue&type=template&id=aaf58816"
import script from "./blockTotal.vue?vue&type=script&lang=js"
export * from "./blockTotal.vue?vue&type=script&lang=js"
import style0 from "./blockTotal.vue?vue&type=style&index=0&id=aaf58816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports